import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        tag: { type: String, default: 'h2' },
        color: { type: String },
    },
});
